import { withDependencies, named, optional } from '@wix/thunderbolt-ioc'
import {
	CurrentRouteInfoSymbol,
	FeatureStateSymbol,
	IPageDidMountHandler,
	PageFeatureConfigSymbol,
	EditorFeatureConfigSymbol,
} from '@wix/thunderbolt-symbols'
import type {
	AutoDisplayLightboxPageConfig,
	AutoDisplayLightboxFeatureState,
	AutoDisplayLightboxEditorPageConfig,
} from '../types'
import { name } from '../symbols'
import { ILightbox, LightboxSymbol } from 'feature-lightbox'
import { IFeatureState } from 'thunderbolt-feature-state'
import { ICurrentRouteInfo } from 'feature-router'
import { autoDisplayLightboxFactory } from '../autoDisplayLightbox'

const autoDisplayLightboxFactoryEditor = (
	pageConfig: AutoDisplayLightboxPageConfig,
	editorConfig: AutoDisplayLightboxEditorPageConfig,
	featureState: IFeatureState<AutoDisplayLightboxFeatureState>,
	currentRouteInfo: ICurrentRouteInfo,
	popupsFeature?: ILightbox
): IPageDidMountHandler => {
	const autoDisplayLightbox = autoDisplayLightboxFactory(pageConfig, featureState, currentRouteInfo, popupsFeature)
	return {
		pageDidMount() {
			if (!editorConfig.isEditMode) {
				autoDisplayLightbox.pageDidMount(pageConfig.triggerPageId)
			}
		},
	}
}

export const AutoDisplayLightbox = withDependencies(
	[
		named(PageFeatureConfigSymbol, name),
		named(EditorFeatureConfigSymbol, name),
		named(FeatureStateSymbol, name),
		CurrentRouteInfoSymbol,
		optional(LightboxSymbol),
	],
	autoDisplayLightboxFactoryEditor
)
